
/* eslint-disable camelcase */
import { view_rights_update_view } from 'common/views/constants';
import { hasRights } from 'common/views/has_rights';
import _ from 'lodash';

export default function(coreView) {
  return hasRights(coreView, view_rights_update_view);
}
